import { sendMetaTransaction } from "decentraland-transactions";
import { Contract } from '@ethersproject/contracts';
import { getConnectedProvider } from "../../../lib/eth";
import { getTargetNetworkProvider } from "./getTargetNetworkProvider";
import { transactionEvents } from "./transactionEvents";
import { TransactionEventType } from "./types";
import { getTransactionsApiUrl } from "./urls";
import { getProviderChainId } from "./getProviderChainId";
export async function sendTransaction(...args) {
    const [contract, contractMethodNameOrGetPopulatedTransaction, ...contractArguments] = args;
    try {
        const connectedProvider = await getConnectedProvider();
        if (!connectedProvider) {
            throw new Error('Provider not connected');
        }
        const chainId = await getProviderChainId(connectedProvider);
        const targetNetworkProvider = await getTargetNetworkProvider(contract.chainId);
        const contractInstance = new Contract(contract.address, contract.abi, targetNetworkProvider);
        // Populate the transaction data
        const unsignedTx = await (typeof contractMethodNameOrGetPopulatedTransaction ===
            'function'
            ? contractMethodNameOrGetPopulatedTransaction(contractInstance.populateTransaction)
            : contractInstance.populateTransaction[contractMethodNameOrGetPopulatedTransaction](...contractArguments));
        // If the connected provider is in the target network, use it to sign and send the tx
        if (chainId === contract.chainId) {
            const signer = targetNetworkProvider.getSigner();
            const tx = await signer.sendTransaction(unsignedTx);
            transactionEvents.emit(TransactionEventType.SUCCESS, { txHash: tx.hash });
            return tx.hash;
        }
        else {
            // otherwise, send it as a meta tx
            const txHash = await sendMetaTransaction(connectedProvider, targetNetworkProvider, unsignedTx.data, contract, {
                serverURL: getTransactionsApiUrl()
            });
            transactionEvents.emit(TransactionEventType.SUCCESS, { txHash });
            return txHash;
        }
    }
    catch (error) {
        const data = {
            type: TransactionEventType.ERROR,
            error: error
        };
        transactionEvents.emit(TransactionEventType.ERROR, data);
        throw error;
    }
}
//# sourceMappingURL=sendTransaction.js.map